// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"504":"chunk-vendors","524":"app"}[chunkId] + "." + {"504":"50c96e12","524":"c3cc48a9"}[chunkId] + ".css";
};